import { WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import { serviceOptions } from "../../../../constants";
import type { ServiceType } from "../../../../types/forms";

export type PartInformation = {
  partNumber: string;
  make: string;
  serviceType: ServiceType;
};

export default function PartInformationCard({
  part,
}: {
  part: PartInformation;
}) {
  return (
    <section className="overflow-hidden rounded-xl border border-gray-100 bg-white">
      <div className="flex items-center gap-2 border-b border-gray-100 px-4 md:px-5 py-4.5">
        <WrenchScrewdriverIcon className="size-5 text-blue-600" />
        <h2 className="text-sm md:text-base font-medium text-gray-950">
          Part Information
        </h2>
      </div>

      <div className="flex flex-col px-4 md:px-5 py-1.5 text-sm">
        <div className="flex items-center justify-between gap-4 border-b border-gray-100 py-3.5 last:border-b-0">
          <span className="shrink-0 text-gray-500">Part Number</span>
          <span className="min-w-0 break-all text-right text-gray-950">
            {part.partNumber}
          </span>
        </div>
        <div className="flex items-center justify-between gap-4 border-b border-gray-100 py-3.5 last:border-b-0">
          <span className="shrink-0 text-gray-500">Make</span>
          <span className="min-w-0 break-all text-right text-gray-950">
            {part.make}
          </span>
        </div>
        <div className="flex items-center justify-between gap-4 border-b border-gray-100 py-3.5 last:border-b-0">
          <span className="shrink-0 text-gray-500">Service Type</span>
          <span className="min-w-0 break-all text-right text-gray-950">
            {serviceOptions.find((o) => o.value === part.serviceType)?.label}
          </span>
        </div>
      </div>
    </section>
  );
}
